export enum ZoneDiversityType {
    Relaxed = "Relaxed",
    Forced = "Forced"
}